export const NAME = 'creatConsultations';